// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessPasswordUpdateBanner_wrapper__vPlMt"};